export const callGeolocation = (lat, lng, callbackSuccess) => {
    //deixar essas duas linhas enquanto não tiver o https
    //callbackSuccess({}, 0)
    return
    if ( navigator.geolocation ) {
        navigator.geolocation.getCurrentPosition( (position) => {
            console.log('position', position)
            console.log('*******************', lat, lng, position.coords.latitude, position.coords.longitude)
            let distanciaEmMetros = distancia(lat, lng, position.coords.latitude, position.coords.longitude)
            callbackSuccess(position, distanciaEmMetros)
        },
        (error) => {
            console.log('error', error)
            switch(error.code){
            case 1:
                //https://support.google.com/chrome/answer/142065?hl=en
                //alert('Seu dispositivo está com a permissão para recuperar localização bloqueada, por favor libere antes de prosseguir.')
                break;
            default:
                //alert('Seu dispositivo precisa ter acesso a sua localização para prosseguir.')
            }
        }, 
        {
            enableHighAccuracy: false,
            timeout: 15000,
            maximumAge: 0
            })
    }else{
        //alert('Seu dispositivo precisa ter acesso a sua localização para prosseguir.')
    }
}

export const checkGeolocation = () => {
    console.log('11111')
    //return new Promise(function(resolve, reject) { resolve(true) })
    return new Promise(function(resolve, reject) {
        resolve(true)
        return
        console.log('navigator.geolocation', navigator.geolocation)
        if ( navigator.geolocation ) {
            console.log('geo entrou aqui')
            navigator.geolocation.getCurrentPosition( (position) => {
                console.log('navigator.geolocation.getCurrentPosition-->', position)
                resolve(true)
            },  (error) => { 
                console.log('error', error)
                switch(error.code){
                case 1:
                    //https://support.google.com/chrome/answer/142065?hl=en
                    //alert(JSON.stringify(error) + '1 Seu dispositivo está com a permissão para recuperar localização bloqueada, por favor libere antes de prosseguir.')
                    resolve(false)
                    break;
                default:
                    //alert('2Seu dispositivo precisa ter acesso a sua localização para prosseguir.')
                    resolve(false)
                }
            }, {maximumAge:Infinity, timeout:10000, enableHighAccuracy:false})
        }else{
            //alert('3Seu dispositivo precisa ter acesso a sua localização para prosseguir.')
            resolve(false)
        }
    })
    
}

//teste online: http://nacionais2017.fpcolumbofilia.pt/Distancia
export const distancia = (lat1, lon1, lat2, lon2) => {
    var R = 6371e3; // metres raio da Terra
    var latitude1 = toRadians(lat1);
    var latitude2 = toRadians(lat2);
    var deltaLatitude = toRadians(lat2-lat1);
    var deltaLongitude = toRadians(lon2-lon1);

    var a = Math.sin(deltaLatitude/2) * Math.sin(deltaLatitude/2) +
            Math.cos(latitude1) * Math.cos(latitude2) *
            Math.sin(deltaLongitude/2) * Math.sin(deltaLongitude/2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

    var d = R * c;

    return d
  }

const toRadians = (value) => {
    return value * Math.PI / 180;
}